import { CookieStorage } from "aws-amplify/utils";
import awsconfig from "../aws-exports";

export function createCookieStorage() {
	return new CookieStorage({
		domain: ".cosmogas.com",
		sameSite: "none",
		secure: true
	});
}

function getRefreshTokenStorageKey(loginId) {
	if (!loginId) {
		return null;
	}

	return `CognitoIdentityServiceProvider.${awsconfig.aws_user_pools_web_client_id}.${loginId}.refreshToken`;
}

export async function getStoredAuthData(session) {
	const cookieStorage = createCookieStorage();
	const loginId = session?.tokens?.signInDetails?.loginId;
	const refreshTokenStorageKey = getRefreshTokenStorageKey(loginId);

	return {
		idToken:
			session?.tokens?.idToken?.toString() ||
			(await cookieStorage.getItem("id_token")),
		accessToken:
			session?.tokens?.accessToken?.toString() ||
			(await cookieStorage.getItem("access_token")),
		refreshToken:
			(refreshTokenStorageKey &&
				localStorage.getItem(refreshTokenStorageKey)) ||
			(await cookieStorage.getItem("refresh_token")),
		userEmail: loginId || (await cookieStorage.getItem("userEmail")),
	};
}

export async function persistAuthData({
	idToken,
	accessToken,
	refreshToken,
	userEmail,
}) {
	const cookieStorage = createCookieStorage();

	// await cookieStorage.setItem("id_token", idToken);
	await cookieStorage.setItem("access_token", accessToken);
	await cookieStorage.setItem("refresh_token", refreshToken);
	await cookieStorage.setItem("userEmail", userEmail);
}

export async function clearStoredAuthData() {
	const cookieStorage = createCookieStorage();

	await cookieStorage.removeItem("access_token");
	await cookieStorage.removeItem("id_token");
	await cookieStorage.removeItem("refresh_token");
	await cookieStorage.removeItem("userEmail");
}
